var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticStyle:{"height":"100vh"}},[_c('el-aside',{attrs:{"width":"220px"}},[_c('Sidebar')],1),_c('el-container',[_c('el-header',{staticStyle:{"height":"60px"}},[_c('Header')],1),_c('el-main',{staticStyle:{"overflow":"auto"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }